'use client';

import { useEffect, useState } from 'react';
import classnames from 'classnames';
import {
  HeroHeaderBlock as V3HeroHeaderBlock,
  HeroHeaderBlockProps,
} from '@stadionhq-v3/base-ui';
import { useScreenSize } from '@stadionhq-v3/hooks';
import { getBreakpointValue } from '@stadionhq-v3/utilities';
import styles from './heroHeaderBlock.module.scss';

export const HeroHeaderBlock = ({ ...props }: HeroHeaderBlockProps) => {
  const { width } = useScreenSize();

  const [isBackgroundCarousel, setIsBackgroundCarousel] =
    useState<boolean>(false);

  useEffect(() => {
    setIsBackgroundCarousel(width < getBreakpointValue('l'));
  }, [width]);

  const classes = classnames([
    styles.heroHeaderBlockTokens,
    styles.heroHeaderBlock,
  ]);

  return (
    <V3HeroHeaderBlock
      {...props}
      classNames={[classes]}
      intervalDuration={10000}
      isBackgroundCarousel={isBackgroundCarousel}
      carouselOptions={{
        breakpoints: {
          1024: {
            perMove: 1,
            perPage: 3,
            drag: false,
            direction: 'ttb',
            height: 352,
          },
        },
      }}
    />
  );
};
